import BoqList from "../../slices/doc/boq/BoqList"
import BoqDetails from "../../slices/doc/boq/BoqDetails"
import DatasheetList from "../../slices/doc/datasheet/DatasheetList"
import DatasheetDetails from "../../slices/doc/datasheet/DatasheetDetails"

const docReducer = {
    boqList: BoqList,
    boqDetails: BoqDetails,
    datasheetList: DatasheetList,
    datasheetDetails: DatasheetDetails,
};

export default docReducer;